import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from '@mui/material';

// AD-2725 (Maria, 17 October 2026): every section of the profile has its heading in this one style, and every part
// within a section (such as each part of Medical Information) has its subheading in the 'sub' style.
const ProfileSectionHeading = ({children, testId, sx, sub}) => (
    <Typography
        variant={sub ? 'subtitle1' : 'h6'}
        component={sub ? 'h3' : 'h2'}
        data-testid={testId}
        sx={sub
            ? {fontWeight: 700, fontSize: 17, color: '#186BBE', mt: 2, mb: 0.5, ...sx}
            : {fontWeight: 600, fontSize: 21, mt: 0, mb: 1, ...sx}}
    >
        {children}
    </Typography>
);

ProfileSectionHeading.propTypes = {
    children: PropTypes.node,
    testId: PropTypes.string,
    sx: PropTypes.object,
    sub: PropTypes.bool
};

export default ProfileSectionHeading;
